import { IonSpinner } from '@ionic/react'

// Loader basique (spinner centré) — rétrocompatible
let Loader: React.FC<{ message?: string }> = ({ message }) => (
  <div
    style={{
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <IonSpinner color="secondary" />
    {message && <span style={{ marginLeft: 12, color: 'var(--ice-text-muted)', fontSize: '0.85rem' }}>{message}</span>}
  </div>
)

// Skeleton table — montre la structure d'un tableau pendant le chargement
export let SkeletonTable: React.FC<{
  columns: string[]
  rows?: number
  message?: string
  title?: string
}> = ({ columns, rows = 8, message, title }) => (
  <div className="tab_container">
    {title && (
      <div style={{ padding: '16px 16px 0' }}>
        <h2 style={{ margin: 0 }}>{title}</h2>
      </div>
    )}
    <div className="ice-skeleton-status">
      <IonSpinner color="primary" style={{ width: 20, height: 20 }} />
      <span>{message || 'Chargement en cours...'}</span>
    </div>
    <div className="table_container">
      <table>
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col}>{col}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, i) => (
            <tr key={i}>
              {columns.map((_, j) => (
                <td key={j}>
                  <span className="ice-skeleton" style={{ display: 'inline-block', width: `${50 + Math.random() * 40}%`, height: '1rem' }}>&nbsp;</span>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
)

// Skeleton cards — pour les KPI (Transactions côté droit)
export let SkeletonCards: React.FC<{
  count?: number
}> = ({ count = 4 }) => (
  <div>
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="table_container big">
        <table>
          <thead>
            <tr>
              <th className="right">
                <span className="ice-skeleton" style={{ display: 'inline-block', width: '70%', height: '0.8rem' }}>&nbsp;</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="right money">
                <span className="ice-skeleton" style={{ display: 'inline-block', width: '50%', height: '1.6rem' }}>&nbsp;</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    ))}
  </div>
)

export default Loader
